import React, { createContext, useState, useEffect } from 'react';
import axios, { reInstance } from './helpers';
import { useSnackbar } from 'notistack';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);


  const logout = async (values) => {
      localStorage.removeItem('token-admin');
      setIsAuthenticated(false);
  };

    

  const login = async (values) => {
    try {
      const response = await axios(true).post('/login', values);
      localStorage.setItem('token-admin', response.data.token);
      setIsAuthenticated(true);
      await reInstance(response.data.token);
      return true;
    }catch (error) {
      const errorMessage = error.response?.data.msg || 'An error occurred';
      enqueueSnackbar(errorMessage, { variant: 'error', autoHideDuration: 1000  });
      return false;
    }
  };

  const register = async (values) => {
    try {
      const response = await axios(true).post('/register', values);
      localStorage.setItem('token-admin', response.data.token);
      setIsAuthenticated(true);
      await reInstance(response.data.token);
      return true
    }catch (error) {
      const errorMessage = error.response?.data.msg || 'An error occurred';
      enqueueSnackbar(errorMessage, { variant: 'error', autoHideDuration: 1000  });
      return false;
    }
  };

  const verifyToken = async () => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem('token-admin');
      if (token) {
        const response = await axios(true).get('/check-tokken-admin', {
          headers: { Authorization: `Bearer ${token}` }
        });

        setIsAuthenticated(Boolean(response.data));
      } else {
        setIsAuthenticated(false);
      }
    } catch (error) {
      setIsAuthenticated(false);
      enqueueSnackbar(error, { variant: 'error', autoHideDuration: 1000  });
    } finally {
      setIsLoading(false);
    }
  };



  return (
    <AuthContext.Provider value={{ isAuthenticated, isLoading, setIsAuthenticated, login, register, verifyToken,logout }}>
      {children}
    </AuthContext.Provider>
  );
};
